import script from "./UploadSingleImage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSingleImage.vue?vue&type=script&setup=true&lang=js"

import "./UploadSingleImage.vue?vue&type=style&index=0&id=55af7b01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55af7b01"]])

export default __exports__